// extracted by mini-css-extract-plugin
export default {"folderNameInput":"FolderNameChange_folderNameInput__h72wm","folderNameChangeButtons":"FolderNameChange_folderNameChangeButtons__Nt7P9"};